import React from "react";
import { Link } from "react-router-dom";
import CheckFollow from "../UserProfile/CheckFollow";

const UserProfileCard = ({ searchUser, user }) => {
  if (!searchUser) {
    return <div className="loading-indicator">Loading...</div>;
  }
  // console.log("The search user is", searchUser);
  return (
    <div
      style={{
        border: "1px solid #0000001A",
        borderRadius: "6px",
        padding: "12px",
        gap: "8px",
      }}
      className="d-flex flex-column align-items-center justify-content-center"
    >
      <Link to={`/userProfile/${searchUser.objectID}`}>
        <img
          src={
            searchUser?.objectUser?.photo ||
            `https://ui-avatars.com/api/?name=${searchUser?.objectUser?.userName[0]?.toUpperCase()}`
          }
          style={{
            borderRadius: "8px",
            width: "70px",
            height: "70px",
            objectFit: "cover",
            objectPosition: "top",
          }}
          alt=""
        />
      </Link>
      <Link to={`/userProfile/${searchUser?.objectID}`} className="w-100">
        <div
          style={{
            fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "16px",
            letterSpacing: "0%",
            color: "#000000",
            textAlign: "center",
          }}
          className="text-truncate"
        >
          {searchUser?.displayName}
        </div>
      </Link>
      {searchUser?.objectID !== user?.uid ? (
        <CheckFollow
          myData={user}
          friendData={searchUser}
          componentName={"UserProfileCard"}
        />
      ) : (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{
            border: "1px solid #005FDA",
            borderRadius: "10px",
            height: "31px",
            width: "70%",
            cursor: "pointer",
          }}
        >
          <Link to={`/userProfile/${searchUser?.objectID}`}>View</Link>
        </div>
      )}
    </div>
  );
};

export default UserProfileCard;
